import { Inject, Injectable, Optional } from '@angular/core';
import { MONITORING_AGENT } from '@app/core/injection-tokens';

import { MonitoringAttributes } from '../enums/monitoring-attributes.enum';

@Injectable()
export class AppMonitoringService {

  constructor(@Inject(MONITORING_AGENT) @Optional() private agent) {}

  get enabled(): boolean {
    return !!this.agent && typeof this.agent === 'object';
  }

  setReleaseVersion(release: string): void {
    if (this.enabled) {
      this.agent.addRelease('EOBI Frontend', release);
    }
  }

  noticeError(error: Error): void {
    if (this.enabled) {
      this.agent.noticeError(error);
    }
  }

  addAttributeToCurrentSession(name: string | MonitoringAttributes, value: any): void {
    if (this.enabled) {
      this.agent.setCustomAttribute(name, value);
    }
  }

  clearAttributeFromCurrentSession(name: string | MonitoringAttributes): void {
    this.addAttributeToCurrentSession(name, undefined);
  }
}
